export const COURSES_HEAD_TITLE = 'Critical Thinking Courses';
export const COURSES_PAGE_TITLE = 'Critical Thinking Courses';

const COURSES_HEAD_DESCRIPTION_TEMPLATE =
    'Self-paced, interactive critical thinking courses for {audience}. Teach your kids about logical fallacies, data analysis, media literacy, emotional intelligence, and more!';

const has_selection = (selected) => selected && selected.path !== '';
const get_audience_label = (selected) =>
    has_selection(selected)
        ? selected.title.toLowerCase().replace(/^for\s+/, '')
        : 'ages 5-18';

export function get_courses_head_title(selected) {
    return has_selection(selected)
        ? `${COURSES_HEAD_TITLE} ${selected.title.toLowerCase()}: Critikid`
        : `${COURSES_HEAD_TITLE} for Kids: Critikid`;
}

export function get_courses_head_description(selected) {
    const audience = get_audience_label(selected);

    return COURSES_HEAD_DESCRIPTION_TEMPLATE.replace('{audience}', audience);
}

export const courses_nav_items = [
    {
        path: '',
        title: 'For All Ages',
        header_suffix: '',
        min_age: null,
        max_age: null
    },
    {
        path: 'for-5-7-years-old',
        title: 'For Ages 5–7',
        header_suffix: 'for Ages 5–7',
        min_age: 5,
        max_age: 7
    },
    {
        path: 'for-8-12-years-old',
        title: 'For Ages 8–12',
        header_suffix: 'for Ages 8–12',
        min_age: 8,
        max_age: 12
    },
    {
        path: 'for-13-and-up',
        title: 'For Ages 13+',
        header_suffix: 'for Ages 13+',
        min_age: 13,
        max_age: 18
    }
];
